export default __webpack_public_path__ + "static/media/background.c0c6153d.jpg";